<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="item in list" :key="item.picId" class="rect" @click="onClickRect(item)">
        <div class="headIcon" @click="onClickRect(item)">
          <van-image
            width="6em"
            height="7.8em"
            fit="cover"
            :src="item.customerInfo&& item.customerInfo.headIcon?item.customerInfo.headIcon:'/img/defaultIcon.jpg'"
            @click="onClickRect(item)"
          />
        </div>
        <div class="state">
          {{ GetEnumText('Em_DivePicState', item.state) }}
        </div>
        <div class="infoRect">
          姓名:{{ item.customerInfo?item.customerInfo.lastName:'未填写' }} {{ item.customerInfo?item.customerInfo.firstName:'' }}<br>
          生日:{{ item.customerInfo && item.customerInfo.birthday?formatDate(item.customerInfo.birthday,"yyyy/MM/dd"):'未填写' }}<br>
          备注:{{ item.remark }}<br>
          {{ item.groupTeam }} {{ item.picTypeName }} {{ item.picCourse }}<br>
          {{ formatDate(item.createTime,"yyyy/MM/dd hh:mm",true) }}<br>
          <van-tag v-if="!item.isShare" round type="primary" plain :color="GetColorMain()">直接注册</van-tag>
          <van-tag v-if="item.isShare" round type="primary" plain :color="GetColorMain()">邀请注册</van-tag>
          <van-tag v-if="item.isFastService" round type="primary" plain :color="GetColorMain()">快速认证</van-tag>
          <van-tag v-if="item.isPhysicsCard" round type="primary" plain :color="GetColorMain()">实体卡</van-tag>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Image, Tag, List } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Tag.name]: Tag,
    [List.name]: List,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '我的待发放证书',
      backurl: '/my/index',
      type: undefined,
      search: {
        limit: 30,
        page: 1
      },
      loading: undefined,
      finished: false,
      list: []
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    var type = getUrlKey('type')
    if (type) {
      this.state = type
    }
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLoad() {
      if (this.loading === undefined) {
        this.loading = true
        return
      }
      this.loading = true
      console.log('this.state', this.state)
      if (this.state === 'ALL') {
        this.search.state = undefined
      } else {
        this.search.state = this.state
      }
      request({
        url: '/pro/PicListUser',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    onClickRect(item) {
      if (item.customerInfo) {
        this.$router.push('/pic/picState/' + item.hashCode)
      } else {
        this.$router.push('/pic/pic/' + item.hashCode)
      }
    }
  }
}
</script>
<style scoped>
.rect{
    position: relative;
    margin: 0.5em 0.5em;
    padding: 0.5em;
    background-color: #fff;
    border-radius: 0.3em;
    height: 8em;
    font-size: 0.9em;
}
.rect .headIcon{
    position: absolute;
    top: 0.6em;
}
.rect .infoRect{
    position: absolute;
    left: 7em;
    right: 0;
    top: 0.3em;
    bottom: 0;
    line-height: 1.4em;
}
.rect  .state{
    position: absolute;
    right: 0.5em;
    top: 0.5em;
    font-weight: 700
}
.rect .infoRect span{
  margin-right: 0.5em;
}
</style>
